/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_time_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide by 60 to get whole hours, then multiply the remainder by 60 for leftover minutes: 150 ÷ 60 = 2 remainder 30, so 150 minutes is 2 hours 30 minutes. This converter shows the decimal value (2.5 hours); splitting it into hours-and-minutes is a quick manual step from there.`)
};

const es_uc_time_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide por 60 para obtener horas completas, luego multiplica el residuo por 60 para minutos sobrantes: 150 ÷ 60 = 2 residuo 30, así que 150 minutos es 2 horas 30 minutos. Este conversor muestra el valor decimal (2.5 horas); dividirlo en horas-y-minutos es un paso manual rápido desde ahí.`)
};

const de_uc_time_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen Sie durch 60, um ganze Stunden zu erhalten, und multiplizieren Sie dann den Rest mit 60, um die restlichen Minuten zu berechnen: 150 ÷ 60 = 2 Rest 30, also sind 150 Minuten 2 Stunden 30 Minuten. Dieser Umrechner zeigt den Dezimalwert (2.5 Stunden); die Aufteilung in Stunden und Minuten ist von dort aus ein schneller manueller Schritt.`)
};

const nl_uc_time_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gedeeld door 60 om hele uren te krijgen, vervolgens vermenigvuldig de rest met 60 voor overgebleven minuten: 150 ÷ 60 = 2 rest 30, dus 150 minuten is 2 uur 30 minuten. Deze convertor geeft de decimale waarde (2.5 uur); het splitsen in uren-en-minuten is een snelle handmatige stap van daar.`)
};

const fr_uc_time_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisez par 60 pour obtenir les heures entières, puis multipliez le reste par 60 pour les minutes restantes : 150 ÷ 60 = 2 reste 30, donc 150 minutes est 2 heures 30 minutes. Ce convertisseur affiche la valeur décimale (2,5 heures) ; le diviser en heures-et-minutes est une étape manuelle rapide à partir de là.`)
};

const it_uc_time_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividi per 60 per ottenere ore intere, quindi moltiplica il resto per 60 per i minuti rimanenti: 150 ÷ 60 = 2 resto 30, quindi 150 minuti sono 2 ore 30 minuti. Questo convertitore mostra il valore decimale (2,5 ore); dividerlo in ore e minuti è un passaggio manuale veloce da lì.`)
};

const pt_br2_uc_time_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida por 60 para obter horas inteiras, depois multiplique o restante por 60 para minutos restantes: 150 ÷ 60 = 2 resto 30, então 150 minutos é 2 horas 30 minutos. Este conversor mostra o valor decimal (2.5 horas); dividi-lo em horas-e-minutos é um passo manual rápido a partir daí.`)
};

const pt_uc_time_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividir por 60 para obter horas inteiras, depois multiplicar o resto por 60 para minutos restantes: 150 ÷ 60 = 2 resto 30, portanto 150 minutos são 2 horas 30 minutos. Este conversor mostra o valor decimal (2,5 horas); dividir em horas-e-minutos é um passo manual rápido de lá.`)
};

const ja_uc_time_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60で除く全時間を取得し、残りの部分に60を乗じる左側の分のため：150 ÷ 60 = 2残る30。したがって150分は2時間30分です。このコンバーターは10進値(2.5時間)を示します。それを時間分に分割することは、そこから簡単な手動ステップです。`)
};

const zh_uc_time_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_time_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_time_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_time_faq4_a", locale)
	if (locale === "en") return en_uc_time_faq4_a(inputs)
	if (locale === "es") return es_uc_time_faq4_a(inputs)
	if (locale === "de") return de_uc_time_faq4_a(inputs)
	if (locale === "nl") return nl_uc_time_faq4_a(inputs)
	if (locale === "fr") return fr_uc_time_faq4_a(inputs)
	if (locale === "it") return it_uc_time_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_time_faq4_a(inputs)
	if (locale === "pt") return pt_uc_time_faq4_a(inputs)
	if (locale === "ja") return ja_uc_time_faq4_a(inputs)
	return zh_uc_time_faq4_a(inputs)
};